export default __webpack_public_path__ + "static/media/card-bogota.2d0a4e40.png";